import Input from "components/EvtKit/input/Input"
import PricingCalculatorElement from "./PricingCalculatorElement"
import PricingExpressionElement from "./PricingExpressionElement"
import PricingCalculatorVariableElement from "./PricingCalculatorVariableElement"
import Button from "components/EvtKit/button/Button"
import Heading from "components/Typography/Heading"

import { PricingTypes } from "pages/purchase-plans/constants/defaultValues"
import { IPricingVariables } from "pages/purchase-plans/hooks/usePricingVariables"
import { useAppSelector } from "reducers/store"

import { memo } from "react"
import styled from "styled-components"
import clsx from "clsx"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  &.internal {
    height: unset;
    overflow-y: unset;
  }
`

const InlineContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
`

const FlexItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  &.internal {
    gap: 0;
  }
`

const InputContainer = styled.div`
  min-width: 468px;
  height: 48px;

  &.internal {
    width: auto;
  }
`

const ButtonContainer = styled.div`
  width: 186px;
`

interface PricingVariablesProps extends IPricingVariables {
  label: string
  pricingType: PricingTypes
}

const PricingVariables = (props: PricingVariablesProps) => {
  const {
    label,
    pricingType,
    list,
    mathExpression,
    isMathExpressionParsed,
    changeElement,
    handleMathExpressionChange,
    onSubmitMathExpression,
    loading
  } = props

  const {
    identifiers: { productId }
  } = useAppSelector((state) => state.purchasePlan)

  const isButtonDisabled = loading || !mathExpression || productId === ""

  const isInternal = pricingType === PricingTypes.VARIABLE_CALCULATOR

  return (
    <Container className={clsx({ internal: isInternal })}>
      <FlexItemContainer className={clsx({ internal: isInternal })}>
        <InlineContainer>
          <InputContainer className={clsx({ internal: isInternal })}>
            <Input
              name="mathExpression"
              value={mathExpression}
              onChange={handleMathExpressionChange}
              label={label}
              shrink
              placeholder="Digite"
              className="fullWidth"
            />
          </InputContainer>

          <ButtonContainer>
            <Button
              className="background-gradient fill-width"
              label="Gerar variáveis"
              onClick={onSubmitMathExpression}
              loading={loading}
              disabled={isButtonDisabled}
              isSmall
            />
          </ButtonContainer>
        </InlineContainer>

        {isMathExpressionParsed && !isInternal && <Heading variant="h6">Variáveis do preço</Heading>}

        <div>
          {isMathExpressionParsed && (
            <>
              {pricingType === PricingTypes.EXPRESSION && (
                <>
                  {list.map((item) => (
                    <PricingExpressionElement key={item.key} item={item} changeElement={changeElement} />
                  ))}
                </>
              )}

              {pricingType === PricingTypes.CALCULATOR && (
                <>
                  {list.map((item) => (
                    <PricingCalculatorElement key={item.key} item={item} changeElement={changeElement} />
                  ))}
                </>
              )}

              {pricingType === PricingTypes.VARIABLE_CALCULATOR && (
                <>
                  {list.map((item) => (
                    <PricingCalculatorVariableElement key={item.key} item={item} changeElement={changeElement} />
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </FlexItemContainer>
    </Container>
  )
}

export default memo(PricingVariables)
